import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';

import { TypeNumberRealIcon } from '../../../../images/icons/WrapSvg';
import { NumPad } from '../../../inputs/NumPad';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/api.form.actions';

import Task from './Task';

const isOutRange = (range, valor) => {
    let result = false;
    if (range && valor) {
        const reference = parseFloat(valor);
        if (range.inferior && range.limiteinferior) {
            result = result || reference < parseFloat(range.inferior);
        } else if (range.inferior) {
            result = result || reference <= parseFloat(range.inferior);
        }
        if (range.superior && range.limitesuperior) {
            result = result || reference > parseFloat(range.superior);
        } else if (range.superior) {
            result = result || reference >= parseFloat(range.superior);
        }
    }
    return result;
};

const getDeviation = (range, valor) => {
    let result = 0;
    if (range && valor) {
        const reference = parseFloat(valor);
        if (range.superior && range.limitesuperior) {
            return parseFloat(range.superior) - reference;
        } else if (range.superior) {
            return parseFloat(range.superior) - 1 - reference;
        }
        if (range.inferior && range.limiteinferior) {
            return parseFloat(range.inferior) - reference;
        } else if (range.inferior) {
            return parseFloat(range.inferior) - 1 - reference;
        }
    }
    return result;
};

class Real extends React.Component {
    state = {
        valor: undefined,
        comment: '',
        point: 0,
        correction: 0,
        message: undefined,
        intervalId: undefined,
        desactivado: false,
        edit: false,
    };

    static getDerivedStateFromProps(props, state) {
        const { data, parentDeactivated } = props;
        if (data !== state.data || parentDeactivated !== state.parentDeactivated) {
            state.valor = data.valor;
            state.desactivado = data.desactivado;
            state.data = data ? JSON.parse(JSON.stringify(data)) : {};
            state.parentDeactivated = parentDeactivated;

            if (data && data.mostrarrango && data.alertable) {
                state.data.nombre =
                    props.data.nombre +
                    ' (' +
                    data.alertable.inferior +
                    ' : ' +
                    data.alertable.superior +
                    ')';
            }
            return state;
        }
        return null;
    }

    handleClick = (name) => {
        if (!this.props.data.disabled && !this.state.edit) {
            this.setState({ edit: true });
        }
    };

    handleCloseNumPad = (input) => {
        const { data } = this.props;
        const valor = isNaN(input) ? undefined : input;
        this.props.setValue(data.codigo, valor, '', false, {});
        this.setState({ valor: valor, edit: false });
    };

    handleDeactive = (data, checked) => {
        this.props.setValue(data.codigo, undefined, '', checked, {});
        this.setState({ desactivado: checked, valor: undefined });
    };

    component = (disabled, edit, valor, modoTest ) => {
        return (
            <div className="flex_full_row align_center">
                <span className="flex_full_row barlow_regular_textwrap c_slate text_align_left">
                    {valor}
                </span>
                {!disabled && edit && (!modoTest || !valor) && <NumPad value={valor} onClose={this.handleCloseNumPad} />}
            </div>
        );
    };

    ColummComponent = (data, valor) => {
        if (data && data.mostrarrango && valor) {
            const value = getDeviation(data.alertable, valor);
            return (
                <div
                    className={
                        'flex_fixed_column_88  display_flex elements_center ' +
                        (!isOutRange(data.alertable, valor) ? 'bg_pea' : 'bg_lipstick')
                    }
                >
                    <div className="barlowcondensed_extralight_number c_white align_center text_align_center">
                        {value}
                    </div>
                    <div className="flex_auto_row center barlow_regular_subtitle_small c_white uppercase text_align_center">
                        <FormattedMessage id={'type_label_deviation'} />
                    </div>
                </div>
            );
        } else {
            return undefined;
        }
    };

    render() {
        const { last, editable } = this.props;
        const { data, valor, edit, desactivado, parentDeactivated } = this.state;

        return (
            <Task
                key={data.codigo}
                data={data}
                desactivado={desactivado}
                red={isOutRange(data.alertable, valor)}
                value={valor}
                icon={<TypeNumberRealIcon color="primary" />}
                text={'type_label_real'}
                column={this.ColummComponent(data, valor)}
                last={last}
                editable={editable}
                component={this.component(
                    !editable || data.disabled || desactivado || parentDeactivated,
                    edit,
                    valor,
                    data.modoTest
                )}
                parentDeactivated={parentDeactivated}
                onClick={() => this.handleClick(data.codigo)}
                onDeactive={this.handleDeactive}
            />
        );
    }
}

Real.propTypes = {
    intl: intlShape.isRequired,
    instance_changes: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => {
    return {
        instance_changes: state.instance_changes,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(injectIntl(Real));



// WEBPACK FOOTER //
// ./src/components/complex/forms/types/Real.js